"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = addLink;
function appendLink({ rel, href }) {
    return new Promise((resolve, reject) => {
        const link = document.createElement('link');
        link.rel = rel;
        link.href = href;
        link.onload = resolve;
        link.onerror = reject;
        document.head.appendChild(link);
    });
}
function linkExists(href) {
    return Boolean(document.querySelector(`link[href="${href}"]`));
}
async function addLink(options) {
    if (!linkExists(options.href)) {
        await appendLink(options);
    }
}
